import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'odq-restart-subscription-form-dialog',
    templateUrl: './restart-form-dialog.component.html',
    styleUrls: ['./restart-form-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RestartFormDialogComponent  {
 
  errorMessage = '';

  constructor(
    public dialogRef: MatDialogRef<RestartFormDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { errorMessage: string},
  ) {
    this.errorMessage = data.errorMessage;
  } 

  save() {
    this.dialogRef.close(true);
  }
}
